import { Chip, List, ListItemButton, ListItemText, Stack, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import type { BoSection } from '../../shared/types'

export interface PreviewSectionListProps {
  sections: BoSection[]
  selectedId?: string
  onSelect: (id: string) => void
}

export default function PreviewSectionList({
  sections,
  selectedId,
  onSelect,
}: PreviewSectionListProps) {
  const { formatMessage } = useIntl()

  return (
    <Stack spacing={0.5}>
      <Typography variant="overline" color="text.secondary">
        {formatMessage({ id: 'avatarStudio.preview.sections' })}
      </Typography>
      <List
        dense={true}
        aria-label={formatMessage({ id: 'avatarStudio.rail.ariaLabel' })}
        sx={{
          py: 0,
          maxHeight: 320,
          overflowY: 'auto',
          overscrollBehavior: 'contain',
        }}
      >
        {sections.map((section) => (
          <ListItemButton
            key={section.id}
            selected={section.id === selectedId}
            onClick={() => onSelect(section.id)}
            data-testid={`preview-section-${section.id}`}
          >
            <ListItemText
              primary={section.displayName ?? section.id}
              primaryTypographyProps={{ noWrap: true }}
              secondary={
                <Chip
                  component="span"
                  size="small"
                  variant="outlined"
                  label={formatMessage({
                    id: `avatarStudio.section.kind.${section.kind}`,
                  })}
                />
              }
              secondaryTypographyProps={{ component: 'span' }}
            />
          </ListItemButton>
        ))}
      </List>
    </Stack>
  )
}
